import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
export var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      rest[_key2] = arguments[_key2];
    }
    return _reduceInstanceProperty(validators).call(validators, function (error, validator) {
      return error || validator.apply(void 0, rest);
    }, undefined);
  };
};
//# sourceMappingURL=composeValidators.js.map